var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactusIconBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44444 5.70588H12.5556M5.44444 9.47059H10.7778M6.33333 14.1765H3.66667C2.95942 14.1765 2.28115 13.879 1.78105 13.3495C1.28095 12.82 1 12.1018 1 11.3529V3.82353C1 3.07468 1.28095 2.35651 1.78105 1.82699C2.28115 1.29748 2.95942 1 3.66667 1H14.3333C15.0406 1 15.7189 1.29748 16.219 1.82699C16.719 2.35651 17 3.07468 17 3.82353V11.3529C17 12.1018 16.719 12.82 16.219 13.3495C15.7189 13.879 15.0406 14.1765 14.3333 14.1765H11.6667L9 17L6.33333 14.1765Z",
    stroke: "#23272E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactusIconBold);
export default __webpack_public_path__ + "static/media/contactusIconBold.5b90b0be8fe137b6f5d6613c27ea5ed8.svg";
export { ForwardRef as ReactComponent };